import React from "react";

const IconFeedbackCorrect = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="43"
    height="44"
    viewBox="0 0 43 44"
    {...props}
  >
    <defs>
      <path id="f72uyofb3a" d="M0 0.025L42.871 0.025 42.871 42.6 0 42.6z" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <g>
        <g>
          <g>
            <g transform="translate(-230.000000, -845.000000) translate(81.000000, 108.000000) translate(149.000000, 737.000000) translate(0.000000, 0.056909)">
              <mask id="loh7va94hb" fill="#fff">
                <use xlinkHref="#f72uyofb3a" />
              </mask>
              <path
                fill="#8BC53D"
                d="M41.613 23.763c.1-.825 1.258-1.599 1.258-2.45 0-.853-1.158-1.627-1.258-2.452-.1-.843.839-1.87.639-2.68-.202-.823-1.51-1.296-1.807-2.078-.3-.79.364-2.013-.026-2.754-.393-.747-1.778-.893-2.254-1.583-.48-.693-.128-2.039-.685-2.668-.558-.63-1.937-.442-2.567-1-.629-.557-.607-1.948-1.3-2.428-.69-.477-1.984.034-2.73-.359-.743-.389-1.055-1.746-1.844-2.047-.782-.295-1.915.512-2.738.31-.81-.199-1.438-1.442-2.282-1.543-.826-.098-1.732.957-2.584.957-.852 0-1.758-1.055-2.583-.957-.844.101-1.473 1.344-2.282 1.543-.823.202-1.956-.605-2.738-.31-.79.3-1.102 1.657-1.844 2.047-.746.393-2.04-.119-2.73.359-.693.479-.672 1.871-1.3 2.429-.63.557-2.01.37-2.567.998-.557.629-.205 1.976-.684 2.67-.478.689-1.863.834-2.256 1.582-.39.74.275 1.963-.025 2.754-.297.78-1.605 1.255-1.807 2.078-.2.81.74 1.837.638 2.68-.1.825-1.257 1.6-1.257 2.451 0 .852 1.157 1.626 1.257 2.451.101.843-.838 1.87-.638 2.68.202.823 1.51 1.297 1.807 2.078.3.791-.365 2.014.025 2.755.393.746 1.778.893 2.255 1.582.48.694.128 2.04.685 2.668.558.63 1.937.442 2.567 1 .628.557.606 1.949 1.3 2.429.689.476 1.984-.035 2.73.359.742.388 1.054 1.745 1.844 2.046.782.296 1.915-.512 2.738-.31.81.2 1.438 1.442 2.282 1.543.825.1 1.731-.956 2.583-.956.852 0 1.758 1.055 2.584.956.844-.1 1.472-1.344 2.282-1.542.823-.203 1.956.605 2.738.31.79-.3 1.101-1.658 1.843-2.047.747-.394 2.04.118 2.731-.36.692-.478.671-1.87 1.3-2.428.63-.558 2.009-.37 2.567-.999.557-.628.205-1.975.684-2.669.477-.69 1.862-.835 2.255-1.582.39-.741-.274-1.964.026-2.755.297-.78 1.605-1.255 1.807-2.078.2-.81-.74-1.837-.639-2.68"
                mask="url(#loh7va94hb)"
              />
            </g>
            <path
              fill="#FFF"
              d="M39.243 21.37c0 9.834-7.973 17.807-17.808 17.807S3.628 31.204 3.628 21.369 11.6 3.561 21.435 3.561c9.835 0 17.808 7.973 17.808 17.808"
              transform="translate(-230.000000, -845.000000) translate(81.000000, 108.000000) translate(149.000000, 737.000000)"
            />
            <path
              fill="#8BC53D"
              d="M38.153 21.76c0 9.053-7.34 16.392-16.394 16.392-9.054 0-16.393-7.339-16.393-16.393s7.34-16.393 16.393-16.393c9.054 0 16.394 7.34 16.394 16.393"
              transform="translate(-230.000000, -845.000000) translate(81.000000, 108.000000) translate(149.000000, 737.000000)"
            />
            <path
              fill="#84BB3A"
              d="M6.475 25.215c0-9.879 7.656-17.886 17.1-17.886 4.14 0 7.936 1.538 10.895 4.098-2.996-3.92-7.72-6.451-13.035-6.451-9.054 0-16.393 7.34-16.393 16.393 0 2.675.64 5.2 1.777 7.43-.225-1.158-.344-2.357-.344-3.584"
              transform="translate(-230.000000, -845.000000) translate(81.000000, 108.000000) translate(149.000000, 737.000000)"
            />
            <path
              fill="#D1D3D4"
              d="M18.174 29.642c-.415 0-.806-.162-1.1-.456l-4.822-4.822c-.293-.293-.455-.683-.455-1.099 0-.415.162-.805.455-1.099.294-.293.684-.455 1.1-.455.414 0 .804.162 1.098.456l3.724 3.723 11.292-11.292c.294-.294.684-.456 1.1-.456.415 0 .805.162 1.098.455.294.294.455.684.455 1.1 0 .415-.161.805-.455 1.098L19.273 29.186c-.294.294-.684.456-1.1.456"
              transform="translate(-230.000000, -845.000000) translate(81.000000, 108.000000) translate(149.000000, 737.000000)"
            />
            <path
              fill="#FFF"
              d="M17.65 29.12c-.414 0-.805-.163-1.098-.456l-4.823-4.823c-.293-.293-.455-.683-.455-1.099 0-.415.162-.805.456-1.099.293-.293.683-.455 1.098-.455.415 0 .806.162 1.1.456l3.723 3.723 11.292-11.292c.294-.294.684-.456 1.1-.456.415 0 .805.162 1.098.456.294.293.455.683.455 1.099 0 .415-.161.805-.455 1.098L18.75 28.664c-.294.293-.684.455-1.1.455"
              transform="translate(-230.000000, -845.000000) translate(81.000000, 108.000000) translate(149.000000, 737.000000)"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default IconFeedbackCorrect;
